import * as React from 'react'

export const SvgSort: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      {...{ className }}
      width='10'
      height='8'
      viewBox='0 0 10 8'
      xmlns='http://www.w3.org/2000/svg'
    >
      <line y1='1.25' x2='10' y2='1.25' stroke='white' strokeWidth='1.5' />
      <line y1='4.25' x2='8' y2='4.25' stroke='white' strokeWidth='1.5' />
      <line y1='7.25' x2='6' y2='7.25' stroke='white' strokeWidth='1.5' />
    </svg>
  )
}
